import words from './word-list.json';

export const validateEngravingMessage = (message: string): boolean => {
  const isMessageMadeOfWhitespaces: boolean =
    !message.replace(/\s/g, '').length && message.length > 0;
  if (isMessageMadeOfWhitespaces) {
    return false;
  }

  const forbiddenWordsPattern = new RegExp(`\\b(${words.join('|')})\\b`, 'gi');
  if (message.match(forbiddenWordsPattern)) {
    return false;
  }

  const asciiPunctuationAndSymbols = '!-/:-@[-`{-~ ';
  const digits = '0-9';
  const latinAlphabet = 'A-Za-z';
  const latinExtended = '¡-žƒǍǎǺ-ǿȘ-ț';
  const spacingModifierLetters = 'ˆˇ˘-˝';
  const greekAlphabet = 'ʹ͵;΄-ΊΌΎ-ώϐϑϕ';
  const cyrillic = 'Ѐ-џ';
  const math = '×÷';
  const allowedSymbolsPattern = new RegExp(
    `^[${asciiPunctuationAndSymbols}${digits}${latinAlphabet}${latinExtended}` +
      `${spacingModifierLetters}${greekAlphabet}${cyrillic}${math}]+$`
  );
  return allowedSymbolsPattern.test(message);
};
